import { Link } from 'react-router-dom';
import { useState } from 'react';

function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm py-4 md:py-5 border-0">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-16 flex items-center justify-between">
        <Link to="/">
          <img
            src="https://static.readdy.ai/image/45f36db358624bab4161a57e418814dc/952de5dd7ee479a30999c64f6b1ab29c.png"
            alt="GO TALENTS"
            className="h-10 md:h-14 w-auto object-contain cursor-pointer"
          />
        </Link>
        <div className="flex items-center gap-3 md:gap-4">
          <Link
            to="/hire-talent"
            className="px-4 py-2 md:px-6 md:py-3 rounded-full text-xs md:text-sm font-semibold bg-[#F49729] text-white hover:bg-[#e08820] transition-colors cursor-pointer whitespace-nowrap"
          >
            Hire Talent
          </Link>
          <Link
            to="/apply-talent"
            className="hidden sm:inline-block px-4 py-2 md:px-6 md:py-3 rounded-full text-xs md:text-sm font-semibold border border-[#111111]/20 text-[#111111] hover:border-[#F49729] hover:text-[#F49729] transition-colors cursor-pointer whitespace-nowrap"
          >
            Apply as Talent
          </Link>
        </div>
      </div>
    </header>
  );
}

function PrivacyContent() {
  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 px-5 md:px-6 lg:px-16 bg-white">
      <div className="max-w-3xl mx-auto">
        <p className="text-[#F49729] text-[10px] md:text-xs font-semibold tracking-[0.25em] uppercase mb-3 md:mb-4">
          Legal
        </p>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111] leading-tight mb-3 md:mb-4">
          Privacy Policy
        </h1>
        <p className="text-sm text-[#61616A] mb-10 md:mb-14">Last updated: September 2026</p>

        <div className="space-y-10 md:space-y-12 text-[#33333A] leading-relaxed">
          <div>
            <p>
              This Privacy Policy ("Policy") describes how GO TALENTS LLC ("GO TALENTS," "we," "us,"
              or "our") collects, uses, discloses, and safeguards personal information in connection
              with gotalentsglobal.com (the "Site") and our accounting and bookkeeping staffing
              services (the "Services"). This Policy applies to two categories of individuals: (i)
              professionals who submit an application to join our talent network ("Candidates"), and
              (ii) representatives of companies that submit a request to hire through GO TALENTS
              ("Clients"). By using the Site or submitting information through it, you acknowledge
              that you have read and understood this Policy.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              1. Information We Collect
            </h2>
            <p className="mb-4">
              We collect personal information that you provide directly to us through the forms
              available on the Site, described below by category.
            </p>
            <div className="space-y-4">
              <div>
                <h3 className="text-base font-semibold text-[#111111] mb-1">
                  From Clients, through our hiring request form
                </h3>
                <p className="text-sm md:text-base">
                  Full name, email address, company name, the accounting or bookkeeping area for
                  which staff is requested, the preferred hiring type and experience level, and any
                  role description voluntarily provided.
                </p>
              </div>
              <div>
                <h3 className="text-base font-semibold text-[#111111] mb-1">
                  From Candidates, through our application form
                </h3>
                <p className="text-sm md:text-base">
                  Full name, email address, phone number, country of residence, LinkedIn profile,
                  area of expertise, experience level, English proficiency level, and availability.
                </p>
              </div>
              <div>
                <h3 className="text-base font-semibold text-[#111111] mb-1">From newsletter subscribers</h3>
                <p className="text-sm md:text-base">Email address only.</p>
              </div>
            </div>
            <p className="mt-4 text-sm md:text-base">
              We do not deploy analytics platforms, advertising pixels, or tracking cookies on the
              Site, and we do not collect browsing behavior beyond the standard technical data a web
              server records when a page is requested (such as IP address and timestamp).
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              2. How We Use Personal Information
            </h2>
            <p className="mb-3">We use the personal information described above to:</p>
            <ul className="list-disc pl-5 space-y-2 text-sm md:text-base">
              <li>Evaluate and process hiring requests submitted by Clients</li>
              <li>Evaluate and process applications submitted by Candidates</li>
              <li>Identify and present Candidates whose qualifications fit a Client's open role</li>
              <li>Correspond with you regarding your request, application, or general inquiry</li>
              <li>Deliver newsletter communications to subscribers who opted in, until they unsubscribe</li>
              <li>Maintain internal business, accounting, and recordkeeping practices</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              3. How We Disclose Personal Information
            </h2>
            <p className="mb-3">
              GO TALENTS acts as an intermediary between Candidates and Clients. This section
              describes, specifically, how personal information moves between the two:
            </p>
            <ul className="list-disc pl-5 space-y-3 text-sm md:text-base">
              <li>
                By submitting an application, a Candidate authorizes GO TALENTS to disclose their
                professional information — including experience, skills, English proficiency, and
                availability — to Client companies for the sole purpose of evaluating that Candidate
                for a specific role.
              </li>
              <li>
                We do not sell personal information to third parties, and we do not disclose it for
                advertising or cross-context behavioral marketing purposes.
              </li>
              <li>
                We may disclose personal information where required by applicable law, regulation,
                legal process, or governmental request, or where necessary to protect the rights,
                property, or safety of GO TALENTS, our users, or the public.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              4. Data Retention
            </h2>
            <p className="text-sm md:text-base">
              We retain personal information for as long as reasonably necessary to fulfill the
              purposes described in this Policy, including maintaining our Candidate network for
              future placement opportunities, and to comply with applicable legal, tax, and
              accounting recordkeeping obligations. Retention periods may vary depending on the
              nature of the information and the purpose for which it was collected. You may request
              earlier deletion at any time, as described in Section 6.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              5. Third-Party and External Services
            </h2>
            <p className="text-sm md:text-base">
              The Site loads typography and icon assets from third-party content delivery networks
              (Google Fonts and jsDelivr). As a standard function of how browsers request web
              content, loading these resources may expose your IP address to those providers. GO
              TALENTS does not control the data practices of these third parties, and we recommend
              reviewing their respective privacy policies for further information.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              6. Your Rights and Choices
            </h2>
            <p className="text-sm md:text-base">
              You may request access to, correction of, or deletion of the personal information we
              hold about you by emailing{' '}
              <a href="mailto:contact@gotalentsglobal.com" className="text-[#F49729] hover:underline">
                contact@gotalentsglobal.com
              </a>
              . We will take reasonable steps to verify your identity before acting on a request, and
              we will respond within a reasonable timeframe. Please note that certain information may
              need to be retained notwithstanding a deletion request, where required to comply with
              our legal or accounting obligations.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              7. Data Security
            </h2>
            <p className="text-sm md:text-base">
              We implement reasonable administrative and technical measures designed to protect
              personal information against unauthorized access, alteration, disclosure, or
              destruction. No method of electronic transmission or storage is completely secure, and
              we cannot guarantee absolute security.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              8. International Data Transfers
            </h2>
            <p className="text-sm md:text-base">
              GO TALENTS operates between Argentina and the United States. By submitting information
              through the Site, you acknowledge that your personal information may be transferred to,
              stored, and processed in a country other than the one in which it was originally
              provided.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              9. Children's Privacy
            </h2>
            <p className="text-sm md:text-base">
              Our Services are directed exclusively at professionals and businesses. We do not
              knowingly collect personal information from individuals under the age of 18, and any
              such information discovered will be deleted promptly.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              10. Changes to This Policy
            </h2>
            <p className="text-sm md:text-base">
              We may revise this Policy from time to time to reflect changes in our practices or for
              other operational, legal, or regulatory reasons. The "Last updated" date at the top of
              this page reflects the date of the most recent revision.
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-3 md:mb-4">
              11. Contact Us
            </h2>
            <p className="text-sm md:text-base">
              Questions or requests regarding this Policy may be directed to{' '}
              <a href="mailto:contact@gotalentsglobal.com" className="text-[#F49729] hover:underline">
                contact@gotalentsglobal.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('form_type', 'newsletter');
      await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch (err) {
      console.error('Newsletter subscription failed:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 z-10">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path d="M0 0L0 40C360 80 720 60 1080 40C1260 30 1380 20 1440 30L1440 0L0 0Z" fill="white" />
        </svg>
      </div>

      <div className="bg-[#f5f0eb] pt-16 md:pt-24 pb-6 md:pb-8 px-5 md:px-6 lg:px-16">
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-14">
            <div className="col-span-2 md:col-span-1">
              <Link to="/">
                <img
                  src="https://static.readdy.ai/image/45f36db358624bab4161a57e418814dc/952de5dd7ee479a30999c64f6b1ab29c.png"
                  alt="GO TALENTS"
                  className="h-12 md:h-20 w-auto object-contain mb-2 cursor-pointer"
                />
              </Link>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-[#111111] uppercase tracking-wider mb-4 md:mb-5">
                <a href="/">Quick Links</a>
              </h4>
              <div className="space-y-3">
                <Link to="/hire-talent" className="block text-sm text-[#61616A] hover:text-[#F49729] transition-colors cursor-pointer">
                  Hire Talent
                </Link>
                <Link to="/apply-talent" className="block text-sm text-[#61616A] hover:text-[#F49729] transition-colors cursor-pointer">
                  Apply as Talent
                </Link>
                <Link to="/privacy" className="block text-sm text-[#61616A] hover:text-[#F49729] transition-colors cursor-pointer">
                  Privacy Policy
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-[#111111] uppercase tracking-wider mb-4 md:mb-5">
                <a href="mailto:contact@gotalentsglobal.com">Contact</a>
              </h4>
              <a
                href="mailto:contact@gotalentsglobal.com"
                className="block text-sm text-[#61616A] hover:text-[#F49729] transition-colors mb-4 cursor-pointer break-all"
              >
                contact@<wbr />gotalentsglobal.com
              </a>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.linkedin.com/company/go-talentsglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-[#61616A] hover:text-[#F49729] hover:shadow-lg transition-all cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-base"></i>
                </a>
              </div>
            </div>

            <div className="col-span-2 md:col-span-1">
              <h4 className="text-xs font-semibold text-[#111111] uppercase tracking-wider mb-3 md:mb-5">Newsletter</h4>
              <p className="text-sm text-[#61616A] mb-3 md:mb-4">
                Stay updated with the latest opportunities and insights.
              </p>
              {submitted ? (
                <div className="bg-[#F49729]/10 rounded-2xl p-4">
                  <p className="text-sm text-[#F49729] font-medium">Thank you for subscribing!</p>
                </div>
              ) : (
                <form id="newsletter-form-privacy" onSubmit={handleSubmit} className="flex gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email"
                    required
                    className="flex-1 min-w-0 px-4 py-3 text-sm bg-white border-0 rounded-full focus:outline-none focus:ring-2 focus:ring-[#F49729]/30 transition-all"
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="px-4 py-3 bg-[#F49729] text-white rounded-full hover:bg-[#e08820] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 flex items-center justify-center"
                  >
                    <i className="ri-arrow-right-line text-sm"></i>
                  </button>
                </form>
              )}
            </div>
          </div>

          <div className="pt-5 md:pt-8 border-t border-[#d9d0c5] flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-xs text-[#7F7F84]">&copy; 2026 GO TALENTS.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white font-['Inter',system-ui,sans-serif]">
      <Header />
      <main>
        <PrivacyContent />
      </main>
      <Footer />
    </div>
  );
}
